var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sede"},[(_vm.sede)?_c('div',[_c('i',{staticClass:"fa fa-home",attrs:{"aria-hidden":"true"}})]):_c('div',[_vm._v(" Não possui sede ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }